import e from"react";import r from"prop-types";const t=({children:r})=>e.createElement("tbody",{className:"bg-surface-subtle text-color"},r);t.propTypes={children:r.any};export{t as default};
